import type { ThesisClaimabilityResponse } from "@patent-studio/api-types";
import { Panel } from "@/components/ui/Panel";

/**
 * What a claim set built from the agreed thesis could be, said before one is
 * proposed: one sentence, and the numbers it was read from beneath it.
 *
 * It refuses nothing and offers nothing to do. A thesis that will claim badly
 * is repaired at Novelty, where the positions and the elements are, so the
 * note is the attorney's cue to go back rather than an action on this page.
 * The server writes both lines, so the page and the record agree word for word.
 */
export function ClaimabilityNote({
  claimability,
}: {
  claimability: ThesisClaimabilityResponse;
}) {
  const plain = !claimability.shallow && !claimability.answered_by_the_art;
  return (
    <Panel
      role="status"
      tone={plain ? undefined : "warning"}
      className="mt-6 text-sm"
    >
      <p className="font-semibold">{claimability.summary}</p>
      <p className={plain ? "mt-1 text-muted-foreground" : "mt-1"}>
        {claimability.detail}
      </p>
    </Panel>
  );
}
